import styled from 'styled-components';
export const SearchContainer = styled.div`
    flex: 1 1 auto;
    padding: 0 33px 0 31px;

    .champ-recherche-label svg.svg-loupe {
        line,
        circle,
        path {
            stroke: ${props => props.theme.searchIcon};
        }
    }
    .recherche {
        .champ-recherche-label {
            margin: 0 15px;
            line-height: 1;
            width: 17px;
            height: 17px;
        }
        .champ-recherche {
            &.input {
                height: 40px;
                border-radius: 3px;
                padding: 0;
            }
            input#champrecherche {
                flex: 1 auto;
                height: 100%;
                width: auto;
                border: none;
                outline: none;
                padding: 0;
                color: ${props => props.theme.searchInputTextColor};
            }
        }
    }
    @media screen and (max-width: ${props => props.theme.mobile}) {
        padding: 0;
        flex: 0 auto;
        margin: 0 20px 0 0;

        .recherche {
            .champ-recherche {
                margin: 0 0 15px;
                &.input {
                    padding: 0 10px;
                }
            }
            .menu-mobile-slide-conteneur {
                padding: 0 20px;
            }
            &.menu-mobile-slide .champ-recherche-label {
                margin: 0 10px 0 0;
            }
        }
    }
`;
export const SearchResults = styled.ul`
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    margin: auto;
    padding: 0;
    z-index: 2;
    background: ${props => props.theme.searchResultBackgroundColor};
    overflow: hidden;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    .resultat {
        display: block;
        width: 100%;
        height: 51px;
        padding: 0 20px;
        border-top: 1px solid ${props => props.theme.searchResultBorderColor};
        &.large {
            height: 80px;
            a + br + a {
                margin-top: 5px;
            }
        }
        &:first-child {
            border: none;
        }
        a {
            text-decoration: none;
            color: ${props => props.theme.searchResultTextColor};
            &:hover {
                opacity: 0.6;
            }
        }
    }
    .resultat-conteneur {
        width: 100%;
        height: 100%;
        text-decoration: none;
        transition: opacity 0.2s cubic-bezier(0.16, 0.49, 0.42, 0.99);
    }
    .partnerName {
        margin-right: auto;
    }
    .resultat-valeur {
        display: flex;
        flex-direction: column;
        text-align: right;
        svg {
            margin: 0 5px 0;
        }
        strong {
            font-size: 16px;
        }
        span {
            color: ${props => props.theme.primary};
            font-weight: ${props => props.theme.boldWeight};
        }
        .value {
            display: flex;
            align-items: center;
            span.isvg {
                line-height: 1;
            }
        }
    }
    .coupon a {
        display: flex;
        align-items: center;
        justify-content: right;
        svg {
            margin: 5px 5px 0 15px;
        }
    }
    @media screen and (max-width: ${props => props.theme.large}) {
        & {
            height: 70%;
            overflow-x: hidden;
            overflow-y: scroll;
            .resultat {
                &.large {
                    height: auto;
                }
                .partnerName {
                    width: 100%;
                    margin-bottom: 5px;
                }
                .resultat-valeur {
                    text-align: left;
                }
                .coupon {
                    width: 100%;
                }
            }
        }
    }
    @media screen and (max-width: ${props => props.theme.mobile}) {
        & {
            position: relative;
            top: initial;
            left: initial;
            right: initial;
            box-shadow: none;
            margin-top: 15px;
            .resultat {
                padding: 10px;
                min-height: 51px;
                height: auto;
                &.large {
                    height: auto;
                }
                .partnerName {
                    width: 100%;
                }
                .coupon {
                    width: auto;
                }
            }
        }
        & > div:first-child {
            border-top: 1px solid ${props => props.theme.searchResultBorderColor};
        }
        & > div:last-child {
            border-bottom: 1px solid ${props => props.theme.searchResultBorderColor};
        }
    }
    @media screen and (max-width: ${props => props.theme.tiny}) {
        & {
            .resultat {
                .resultat-valeur {
                    width: 100%;
                }
                .coupon {
                    width: 100%;
                }
            }
        }
    }
`;



// WEBPACK FOOTER //
// ./src/components/header/search/SearchComponentStyle.js